import MarkdownContent from "../components/MarkdownContent";

const Employment: React.FC = () => (<MarkdownContent content={require("../data/employment.md")}/>);
export default Employment;